










































export default {
  name: 'PlanCardSimple',
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isDisabled() {
      return ['current', 'lower-tier'].includes(this.plan.status);
    },
  },
};
